export const toggleBodyOverflow = () => {
    document.body.classList.toggle('overflow-hidden');
};
